'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _last2 = require('lodash/last');

var _last3 = _interopRequireDefault(_last2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _myPlaylists = require('redux/modules/my-playlists');

var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _reduxForm = require('redux-form');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _myPlaylists2 = require('helpers/my-playlists');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./MyPlaylistsCreateBar.scss');

var MyPlaylistsCreateBar = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    prop: state.myPlaylists.prop
  };
}, (0, _extends3.default)({}, myPlaylistsActions)), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'createMyPlaylistForm',
  propNamespace: 'createMyPlaylistForm',
  initialValues: {
    name: ''
  }
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(MyPlaylistsCreateBar, _Component);

  function MyPlaylistsCreateBar() {
    (0, _classCallCheck3.default)(this, MyPlaylistsCreateBar);
    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistsCreateBar.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistsCreateBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyPlaylistsCreateBar, [{
    key: 'submit',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(formData) {
        var _props, addMyPlaylist, checkPlaylist, checkCreated, onCreated, reset, promise, resp, playlist;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, addMyPlaylist = _props.addMyPlaylist, checkPlaylist = _props.checkPlaylist, checkCreated = _props.checkCreated, onCreated = _props.onCreated, reset = _props.createMyPlaylistForm.reset;
                promise = addMyPlaylist(formData).promise;
                _context.next = 4;
                return promise;

              case 4:
                resp = _context.sent;
                playlist = (0, _last3.default)(resp.data);

                reset();
                if (checkCreated) {
                  checkPlaylist({ guid: playlist.guid });
                }
                onCreated({ playlist: playlist });
                return _context.abrupt('return', promise);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submit(_x) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          t = _props2.t,
          disabled = _props2.disabled,
          _props2$createMyPlayl = _props2.createMyPlaylistForm,
          handleSubmit = _props2$createMyPlayl.handleSubmit,
          submitting = _props2$createMyPlayl.submitting,
          invalid = _props2$createMyPlayl.invalid;

      var isDisabled = invalid || disabled;

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(className) },
        _react2.default.createElement(
          'h4',
          null,
          t('Create new Playlist')
        ),
        _react2.default.createElement(
          'form',
          { onSubmit: handleSubmit(this.submit), className: styles.form },
          _react2.default.createElement(
            'div',
            { className: styles.inputContainer },
            _react2.default.createElement(_reduxForm.Field, {
              component: 'input',
              type: 'text',
              name: 'name',
              placeholder: t('Name'),
              maxLength: _myPlaylists2.nameMaxLength,
              required: true
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-right' },
            _react2.default.createElement(
              _Button2.default,
              { type: 'submit', className: 'btn-default', disabled: isDisabled, loading: submitting },
              t('Add')
            )
          )
        )
      );
    }
  }]);
  return MyPlaylistsCreateBar;
}(_react.Component), _class3.propTypes = {
  addMyPlaylist: _propTypes2.default.func,
  checkCreated: _propTypes2.default.bool,
  checkPlaylist: _propTypes2.default.func,
  className: _propTypes2.default.string,
  createMyPlaylistForm: _propTypes2.default.object,
  disabled: _propTypes2.default.bool,
  onCreated: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  onCreated: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = MyPlaylistsCreateBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MyPlaylistsCreateBar/MyPlaylistsCreateBar.js
// module id = 2032
// module chunks = 1